var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNoPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.7917C2 12.4618 2 7.79685 4.89842 4.89842C7.79685 2 12.4618 2 21.7917 2C31.1215 2 35.7865 2 38.685 4.89842C41.5833 7.79685 41.5833 12.4618 41.5833 21.7917C41.5833 31.1215 41.5833 35.7865 38.685 38.685C35.7865 41.5833 31.1215 41.5833 21.7917 41.5833C12.4618 41.5833 7.79685 41.5833 4.89842 38.685C2 35.7865 2 31.1215 2 21.7917Z",
    stroke: "#999999",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0417 28.0417L32.2083 32.2083M30.125 20.75C30.125 15.5723 25.9277 11.375 20.75 11.375C15.5723 11.375 11.375 15.5723 11.375 20.75C11.375 25.9277 15.5723 30.125 20.75 30.125C25.9277 30.125 30.125 25.9277 30.125 20.75Z",
    stroke: "#A7A8AA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNoPromotion);
export default __webpack_public_path__ + "static/media/icn_no_promotion.03b7b80149dbd78441b2cbf6e2e603d8.svg";
export { ForwardRef as ReactComponent };